import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-background text-muted" data-id="element-69" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-accent" aria-hidden="true" data-id="element-70" data-mp="3ggtwodvnbb34" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-71" data-mp="32onj8zjvni7d">
        <p className="text-xs" data-id="element-72" data-mp="32m1et8sa9itd">© 2026 {productShortName}. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}